import { UseFormReset } from 'react-hook-form';

import { FormProvider } from 'core/states';
import { QuoteEntityType } from 'quotes/enums';
import { useQuoteActions } from 'quotes/hooks';
import { IVendorQuote } from 'quotes/types';

import { mapCreateVendorQuoteForm } from './mappers';
import { upsertVendorQuoteSchema } from './schema';
import { IVendorQuoteCreateForm } from './types';
import {
  TVendorQuoteUpsertDisabledFields,
  TVendorQuoteUpsertHiddenFields,
  VendorQuoteUpsertForm,
} from './VendorQuoteUpsertForm';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: IVendorQuote) => void;
  defaultValues?: Partial<IVendorQuoteCreateForm>;
  disabledFields?: TVendorQuoteUpsertDisabledFields;
  hiddenFields?: TVendorQuoteUpsertHiddenFields;
  entityType?: QuoteEntityType;
}

export const VendorQuoteUpsert = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues = null,
  disabledFields = {},
  hiddenFields = {},
  entityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const { upsertVendorQuote } = useQuoteActions({ entityType });

  const handleOnSubmit = () => async (data: IVendorQuoteCreateForm) => {
    const { success, quote } = await upsertVendorQuote(
      mapCreateVendorQuoteForm(data, entityType) as Partial<IVendorQuote>
    );

    if (!success) {
      return;
    }

    onSubmit(quote);
  };

  const handleOnClose = (reset: UseFormReset<IVendorQuoteCreateForm>) => {
    onClose();
    reset(defaultValues);
  };

  return (
    <FormProvider
      schema={upsertVendorQuoteSchema(entityType)}
      defaultValues={defaultValues}
      resetDefaultValues
    >
      <VendorQuoteUpsertForm
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={handleOnSubmit}
        disabledFields={disabledFields}
        hiddenFields={hiddenFields}
        entityType={entityType}
      />
    </FormProvider>
  );
};
